/**
 * 商品DNA情報一覧画面出力用VOクラス
 *
 * @export KYMW4300OutputModel
 * @class KYMW4300OutputModel
 */
export class KYMW4300OutputModel {

  // 商品企画マスタ選択時の独自パラメータ
  // 受注コード(From)
  public orderCodeFrom: string = <string>'';
  // 受注コード(To)
  public orderCodeTo: string = <string>'';
  // 媒体
  public mediumType: string = <string>'';

  // 商品マスタ選択時の独自パラメータ
  // 取引停止商品
  public dealStopGoodsDisplay: string = <string>'';

  // 通常検索タブ
  // Pコード
  public pcode: string = <string>'';
  // アイテムコード
  public itemCode: string = <string>'';
  // 仕様書コード
  public ebaseSpecCode: string = <string>'';
  // データ種別
  public dataType: string = <string>'';
  // JANコード
  public janCode: string = <string>'';
  // メーカ名
  public makerName: string = <string>'';
  // 商品案内用商品名
  public guideGoodsNameList: Array<any> = new Array<any>();
  // 商品案内用規格名
  public guideStandardNameList: Array<any> = new Array<any>();
  // 業態区分（ウィークリー）
  public dutiesFormWeekly: string = <string>'';
  // 業態区分（デイリー）リスト
  public dutiesFormDailyList: Array<any> = new Array<any>();
  // ＤＮＡ情報リスト
  public dnaDivList: Array<any> = new Array<any>();
  // 業態区分（スポット）
  public dutiesFormSpot: string = <string>'';
  // 発注先コード
  public ordrClientCode: string = <string>'';
  // 発注先名称
  public ordrClientKanji: string = <string>'';
  // 支払先コード
  public payeeClientCode: string = <string>'';
  // 支払先名称
  public payeeClientKanji: string = <string>'';
  // 部門コード
  public classCode: string = <string>'';
  // 中分類コード
  public middleClassCode: string = <string>'';
  // 小分類コード
  public smallClassCode: string = <string>'';
  // 商品マスタ登録日チェック
  public registDateCheck = false;
  // 商品マスタ登録日From
  public registDateFrom: string = <string>'';
  // 商品マスタ登録日To
  public registDateTo: string = <string>'';
  // 商品マスタ更新日チェック
  public updateDateCheck = false;
  // 商品マスタ更新日From
  public updateDateFrom: string = <string>'';
  // 商品マスタ更新日To
  public updateDateTo: string = <string>'';
  // 生協コード
  public coopCodeList: Array<any> = new Array<any>();
  // 登録レベル
  public admitStatus: string = <string>'';
  // バイヤーコード
  public buyerCode: string = <string>'';
  // 商品区分(0:通常商品、1:ダミー商品)
  public goodsDiv: string = <string>'';

  // リスト検索タブ
  // Ｐコードリスト
  public pcodeList: Array<any> = new Array<any>();

  // フラグ 初期値はデフォルトの通常検索タブの「0」に設定
  // 検索区分「0：通常検索タブ」、「1：リスト検索タブ」
  public searchKbn: number = <number>0;
}
